export const allowAddSubapplication = (isAllow) => ({
  type: 'ALLOW_ADD_SUB_APPLICATION',
  isAllow: isAllow,
});
